'use client';
import { ComponentType } from 'react';
import { PlaceholderConfig } from '@spa/lib/react/context/PlaceholderContext';
import { Props } from './store-details.component';
import dynamic from 'next/dynamic';

const DynamicStoreDetailsComponent: ComponentType<Props> = dynamic(
  () => import('./store-details.component')
);

export default DynamicStoreDetailsComponent;

export function calculateStoreDetailsPlaceholderConfig(): PlaceholderConfig {
  return {
    heightSinceWidth: [{ sinceWidth: 0, height: 0 }]
  };
}
